export default __webpack_public_path__ + "static/media/ravenous_hydra.5067df0a.png";